import './bookings.css'
import {
    Container,
    Card,
    Col,
    Row,
    Button,
    Modal,
    InputGroup,
    FormControl,
} from "react-bootstrap";
// import { useHistory } from "react-router-dom";
// import { useForm } from "react-hook-form";
import React, { useState, useEffect, useRef, useCallback } from "react";
import ParseBooking from '../../parse-booking';
import axios from "axios";
import SyncLoader from "react-spinners/SyncLoader";
import _ from "lodash";
// import { LinkContainer } from 'react-router-bootstrap';

const INPUT_TIMEOUT = 300; // measured in ms

export default function NoShow (props) {
    // console
    const clinic_id = props.clinic_id;
    // const {register, handleSubmit} = useForm();
    const [show, setShow] = useState(false);
    const [bookingTime, setBookingTime] = useState('');
    const [times, setTimes] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(null);

    const [query, setQuery] = useState('');
    const autoCompleteRef = useRef(null);

    const handleClose = () => setShow(false);
    // const times = props.times;
    // let history = useHistory();

    const handleChange = (event) => {
      setLoading(true);
      setQuery(event.target.value)
      debounce(event.target.value);
    }

    const debounce = useCallback(
      _.debounce((_searchVal) => {
        // send the server request here
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/query-confirmed-bookings", {query: _searchVal})
        .then(response => {
          setTimes(response.data);
          setLoading(false)
          // use/access the results 
        }).catch(errors => {
          console.log(errors)
          setLoading(false)
        })
      }, INPUT_TIMEOUT),
      []
    );

    const changeTime = (time) => {
      console.log(time)
      let booking = ParseBooking(time)
      setBookingTime(booking)
      setShow(true);
    };

    useEffect(() => {
        setLoading(true);
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/no-shows", {clinic_id, no_show:true})
        .then((times) => {
            console.log(times.data.bookings);
            setTimes(times.data.bookings);
            setLoading(false);
            console.log('Times Done')
        },
        (error) => {
            setLoading(false);
            // setError(error);
        });
    }, [clinic_id]);


    //   const onSubmit = async (phone) => {
    //     let data = bookingData;
    //     data.customer_phone = phone.phone;
    //     console.log(data)
    //     history.push({
    //       pathname: '/booking/register',
    //       state: { bookingData: data }
    //     });
    // }
        return (
            <Container className='p-0'>
                <Card className="card my-3">
                    <Card.Header>Reserved bookings</Card.Header>
                    <Card.Body>
                        <Card.Text>
                        Here is the list of all no shows.
                        </Card.Text>
                    </Card.Body>
                </Card>
                <InputGroup className='my-3'>
                <FormControl 
                    // size='lg' 
                    placeholder="Find customers by name. Later email and phone number will be added." 
                    name="customer"
                    ref={autoCompleteRef}
                    onChange={(event) => handleChange(event)}
                    value={query}
                />     
                </InputGroup>

                <SyncLoader size={20} margin={3} color={"#123abc"} loading={loading} />

            {times.filter(item => item.title !== "Blocked").map((time) => (
            <Card key={time._id} className="card mb-3">
              <Card.Body>
                <Row xs={12} md={12} lg={12}>
                  <Col xs={12} md={6} lg={4}>
                    <h6>{time.title}</h6>
                    <Card.Text>
                            {ParseBooking(time)}
                    </Card.Text>
                  </Col>

                  <Col xs={12} md={6} lg={4}>
                    <h6>{time.customer_name}</h6>
                    <Card.Text>
                            +{time.customer_phone} <br/>
                            {time.customer_email} 
                    </Card.Text>
                  </Col>
                  <Col xs={12} md={6} lg={2}>
                    <Card.Text>
                            {time.price} AED
                    </Card.Text>
                  </Col>
                  <Col xs={12} md={6} lg={2}>
                    <Button
                                className="float-right"
                                variant="info"
                                onClick={() => changeTime(time)}
                              >
                                Change
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}


          <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Work in progress</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{bookingTime}</p>
    
            {/* <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="phone">
                <Form.Label>Phone Number*</Form.Label>
                <Form.Control required placeholder="Enter Phone Number" name="phone" ref={register ({required:true})} />
                <Form.Text className="text-muted">
                    We'll never share your phone number with anyone else.
                </Form.Text>
            </Form.Group>
            <Button variant="primary" type="submit">
                Next
            </Button>
            </Form> */}
          </Modal.Body>
          </Modal>
          </Container>
        );
      }
    